import React from "react";
import { logo } from "../../../assets";

const LogoContainer = () => {
  return (
    <div className="sm:px-7 flex-none">
      <img src={logo} className="w-[160px]" alt="logo" />
    </div>
  );
};

export default LogoContainer;
